import { AutomationHardwareItemType } from "../enums/automation-hardware-item-type.enum";

// Part-number prefix per automation hardware item type. Part numbers are formatted as
// `[prefix]-[4 digit code]` (mirrors the plastics hardware item scheme). Each prefix is unique
// so the type is recognizable from the part number alone.
export const AutomationHardwareItemTypePrefix: Record<AutomationHardwareItemType, string> = {
    [AutomationHardwareItemType.Miscellaneous]: 'M',
    [AutomationHardwareItemType.CircuitProtection]: 'CP',
    [AutomationHardwareItemType.Switching]: 'SW',
    [AutomationHardwareItemType.PLC]: 'PLC',
    [AutomationHardwareItemType.Servo]: 'SV',
    [AutomationHardwareItemType.VFD]: 'VFD',
    [AutomationHardwareItemType.Safety]: 'SF',
    [AutomationHardwareItemType.UserInterface]: 'UI',
    [AutomationHardwareItemType.TerminalBlocks]: 'TB',
    [AutomationHardwareItemType.Conductors]: 'CD',
    [AutomationHardwareItemType.Enclosers]: 'EN',
    [AutomationHardwareItemType.Connectors]: 'CN',
    [AutomationHardwareItemType.Pnuematics]: 'PN',
    [AutomationHardwareItemType.Networking]: 'NW',
    [AutomationHardwareItemType.PowerConversion]: 'PC',
};
